import { render, staticRenderFns } from "./HeadDesti.vue?vue&type=template&id=f2de1322&"
import script from "./HeadDesti.vue?vue&type=script&lang=js&"
export * from "./HeadDesti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports